import { createSlice } from "@reduxjs/toolkit";
import { browserNotSupported, isMobileDevice } from "helpers/deviceHelpers";
import { signMeOut } from "./authSlice";
import { leaveSpace } from "./spaceSlice";
let dispatch = null;
// let getState = null;
import("Store").then((module) => {
  dispatch = module.store.dispatch;
  // getState = module.store.getState;
});

export const slice = createSlice({
  name: "general",
  initialState: {
    generalModal: null,
    // of form:
    //  title:
    //  content:
    //  noBackDropClick:
    appModalNodeId: null,
    appModalAppId: null,
    guestInfo: null,
    socketConnectionDrops: 0,
    gridHeight: 0,
    gridWidth: 0,
    modalActive: 0,
    inputBoxActive: false,
    helperList: [],
    flowList: [],
  },
  reducers: {
    setGeneralModal: (state, action) => {
      state.generalModal = action.payload;
    },
    resetGeneralModal: (state) => {
      state.generalModal = null;
    },
    setAppModal: (state, action) => {
      let { nodeId, appId } = action.payload;
      state.appModalNodeId = nodeId;
      state.appModalAppId = appId;
    },
    resetAppModal: (state) => {
      state.appModalNodeId = null;
      state.appModalAppId = null;
    },
    setGuestInfo: (state, action) => {
      state.guestInfo = action.payload;
    },
    setSocketConnectionDrops: (state, action) => {
      state.socketConnectionDrops = action.payload;
    },
    setGridSize: (state, action) => {
      let { width, height } = action.payload;
      state.gridWidth = width;
      state.gridHeight = height;
    },
    setModalActive: (state, action) => {
      if (action.payload) state.modalActive++;
      else state.modalActive--;
    },
    setInputBoxActive: (state, action) => {
      state.inputBoxActive = action.payload;
    },
    setFlowList: (state, action) => {
      state.flowList = action.payload;
    },
    completeFlow: (state) => {
      state.flowList.shift();
    },
    closeFlowList: (state) => {
      state.flowList = [];
    },
    setHelperList: (state, action) => {
      state.helperList = action.payload;
    },
    closeHelper: (state) => {
      state.helperList.shift();
    },
    closeHelperList: (state) => {
      state.helperList = [];
    },
    resetSocketConnectionDrops: (state) => {
      state.socketConnectionDrops = 0;
    },
  },
});

export const {
  setGeneralModal,
  resetGeneralModal,
  setAppModal,
  resetAppModal,
  setGuestInfo,
  setSocketConnectionDrops,
  setModalActive,
  setInputBoxActive,
  setGridSize,
  setFlowList,
  completeFlow,
  closeFlowList,
  setHelperList,
  closeHelper,
  closeHelperList,
  resetSocketConnectionDrops,
} = slice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectSocketDrops = (state) => state.general.socketConnectionDrops;
export const selectGeneralModal = (state) => state.general.generalModal;
export const selectAppModalNodeId = (state) => state.general.appModalNodeId;
export const selectAppModalAppId = (state) => state.general.appModalAppId;
export const selectGuestInfo = (state) => state.general.guestInfo;
export const selectWindowWidth = (state) => state.general.windowWidth;
export const selectWindowHeight = (state) => state.general.windowHeight;
export const selectModalActive = (state) => state.general.modalActive !== 0;
export const selectInputBoxActive = (state) => state.general.inputBoxActive;
export const selectFocusedHelper = (state) => state.general.helperList[0];
export const selectHelperList = (state) => state.general.helperList;
export const selectFlowList = (state) => state.general.flowList;

export default slice.reducer;

export const resetAllState = () => {
  leaveSpace();
  dispatch({ type: "RESET_ALL_STATE" });
};

export const resetWebAppWithError = (errorName, errorContent) => {
  window.log("Reset Web App With ErrorName: " + JSON.stringify(errorName));
  window.log(
    "Reset Web App With ErrorContent: " + JSON.stringify(errorContent)
  );
  signMeOut().then(() => {
    dispatch(setGeneralModal({ title: errorName, content: errorContent }));
  });
};

export const serverDownReset = (serverMessage = null) => {
  if (serverMessage) {
    resetWebAppWithError("Trouble connecting to the Server", serverMessage);
  } else {
    resetWebAppWithError(
      "Trouble connecting to the Server",
      "Your internet connection may be down or we may be fixing an issue. Try restarting your browser if the issue persists."
    );
  }
};

export const addSocketConnectionDrops = () => async (dispatch, getState) => {
  let sockDrops = getState().general.socketConnectionDrops;
  dispatch(setSocketConnectionDrops(sockDrops + 1));
};

export const checkDeviceAndBrowser = () => async (dispatch) => {
  return new Promise((res, rej) => {
    if (isMobileDevice()) {
      dispatch(
        setGeneralModal({
          title: "Mobile Devices Will Be Supported Soon!",
          content: "Please sign in on a desktop browser for now.",
        })
      );
      rej();
    } else if (browserNotSupported()) {
      dispatch(
        setGeneralModal({
          title: "This browser is not supported.",
          content:
            "Please sign in on a modern desktop browser such as Google Chrome, Safari, Microsoft Edge or Firefox.",
        })
      );
      rej();
    } else {
      res();
    }
  });
};

export const performNextFlow = () => {};
